export default "__VITE_ASSET__f120c9ec__"